import React, { createContext, ReactNode, useContext } from 'react';
import DataStore from '../../core/stores/DataStore';
import { InvestStore } from '../../core/stores/InvestStore';
import OnboardingStore from '../../core/stores/OnboardingStore';
import AppStore from '../stores/AppStore';

interface DataStoreProviderProps {
  children: ReactNode;
  appStore: any;
  dataStore: any;
  investStore: any;
  onboardingStore: any;
}

const StoresContext = createContext({
  appStore: new AppStore(),
  dataStore: new DataStore(),
  investStore: new InvestStore(),
  onboardingStore: new OnboardingStore(),
});

export const useAppStore = () => useContext(StoresContext).appStore;
export const useDataStore = () => useContext(StoresContext).dataStore;
export const useInvestStore = () => useContext(StoresContext).investStore;
export const useOnboardingStore = () => useContext(StoresContext).onboardingStore;

const StoresProvider = ({ children, appStore, dataStore, investStore, onboardingStore }: DataStoreProviderProps) => {
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const stores = {
    appStore,
    dataStore,
    investStore,
    onboardingStore,
  };

  return <StoresContext.Provider value={stores}>{children}</StoresContext.Provider>;
};

export default StoresProvider;
